import AssetDocumentsTable from "./AssetDocumentsTable";

export default AssetDocumentsTable;
